import { Heart, CheckCircle } from "lucide-react";
import { motion } from "framer-motion";
import { useLocation } from "react-router-dom";

export default function ThankYouInvitee() {
  const location = useLocation();
  const userName = location.state?.userName;

  return (
    <div className="min-h-screen bg-background flex items-center">
      <div className="max-w-2xl mx-auto px-4 text-center">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="bg-secondary rounded-xl border border-secondary-border p-8"
        >
          <div className="w-20 h-20 bg-primary rounded-lg flex items-center justify-center mx-auto mb-6">
            <CheckCircle className="text-primary-foreground text-3xl" />
          </div>
          <h1 className="text-4xl font-bold text-foreground mb-4">Thank You!</h1>
          <p className="text-[18px] text-muted-foreground mb-8">
            Your thoughtful questions have been submitted and will help create a meaningful legacy story{userName ? ` for ${userName}` : ''}.
          </p>
          <div className="bg-background rounded-[4px] border border-secondary-border p-6 mb-8">
            <h3 className="text-[18px] font-semibold text-foreground mb-2">What happens next?</h3>
            <p className="text-muted-foreground">
              Your questions will be reviewed and incorporated into the upcoming legacy recording session.
            </p>
          </div>
          <p className="text-[18px] text-muted-foreground">
            Questions? Contact us at{' '}
            <a 
              href="mailto:postscrypt@rightlegalgroup.com" 
              className="text-primary hover:text-primary/90 transition-colors font-semibold"
            >
              postscrypt@rightlegalgroup.com
            </a>
          </p>
        </motion.div>
      </div>
    </div>
  );
} 